'use strict';

export default function routes($routeProvider) {
  'ngInject';
  $routeProvider
    .when('/', {
      template: '<main></main>',
      authenticate: true
    });
};




// WEBPACK FOOTER //
// ./client/app/main/main.routes.ts